import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AnalyticsFacade } from '@amfam/shared/analytics';
import { userQuery, UserState } from '@amfam/shared/user';
import { LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'app-claim-landing',
  templateUrl: './claim-landing.component.html',
  styleUrls: ['./claim-landing.component.scss'],
  standalone: false
})
export class ClaimLandingComponent implements OnInit, OnDestroy {
  private currentUser: UserState;

  private currentUserSub: Subscription;

  constructor(
    private store: Store<fromRoot.RootState>,
    private pageTitle: PageTitleService,
    public spinner: LoadingSpinnerService,
    private analyticsFacade: AnalyticsFacade
  ) {}

  ngOnInit() {
    this.spinner.start();
    this.pageTitle.set('Claims');
    this.currentUserSub = this.store.select(userQuery.selectUserState).subscribe(user => {
      this.currentUser = user;
      this.spinner.stop();
    });
  }

  ngOnDestroy() {
    if (this.currentUserSub) {
      this.currentUserSub.unsubscribe();
    }
  }
}
